(() => {
  if (window.pyHistoryTimeline) { window.pyHistoryTimeline.scan(); return; }
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    if (instances.has(root)) return;
    const groups = [...root.querySelectorAll('[data-timeline-year]')];
    if (!groups.length) return;
    let reveal;
    if (root.hasAttribute('data-reveal-years') && !reduced.matches && typeof IntersectionObserver === 'function') {
      root.classList.add('is-reveal-ready');
      reveal = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
      }), {threshold:0.05,rootMargin:'0px 0px -5% 0px'});
      groups.forEach(group => reveal.observe(group));
      groups.slice(0,2).forEach(group => group.classList.add('is-visible'));
    }
    const controller = new AbortController(), {signal} = controller;
    const year = root.querySelector('[data-current-year]'), count = root.querySelector('[data-count]');
    const arrow = root.querySelector('[data-arrow]'), links = [...root.querySelectorAll('[data-year-link]')];
    const chapters = root.querySelector('.py-vtl__chapters');

    const stickyNavigation = !!chapters;
    const header = stickyNavigation ? document.querySelector('.section-header') : null;
    const stickyHeader = header?.querySelector('sticky-header');
    const headerTransitions = new Set();
    let frame = 0, active = -1, pending = -1, settleTimer = 0, jumpTimer = 0;
    const clamp = (value,min,max) => Math.max(min,Math.min(max,value));
    function setLength(key,value) {
      const text = value.toFixed(2)+'px';
      if (root.style.getPropertyValue(key) !== text) root.style.setProperty(key,text);
    }
    function headerSpace() {
      if (!header) return {visible:0,full:0};
      const box = header.getBoundingClientRect();
      return {visible:box.top <= 1 ? clamp(box.bottom,0,box.height) : 0,full:box.height};
    }
    function revealYear(index,animate) {
      const link = links[index];
      if (!stickyNavigation || !link || chapters.scrollWidth <= chapters.clientWidth) return;
      const box = link.getBoundingClientRect(), rail = chapters.getBoundingClientRect();
      if (box.left >= rail.left+12 && box.right <= rail.right-12) return;
      chapters.scrollTo({left:clamp(chapters.scrollLeft+box.left-rail.left-(rail.width-box.width)/2,0,chapters.scrollWidth-chapters.clientWidth),behavior:animate&&!reduced.matches?'smooth':'instant'});
    }
    function select(index) {
      if (active === index) return;
      active = index;
      groups.forEach((group,i) => group.classList.toggle('is-active',i===index));
      if (year) year.textContent=groups[index].dataset.timelineYear;
      if (count) count.textContent=String(index+1).padStart(2,'0')+' / '+String(groups.length).padStart(2,'0');
      links.forEach((link,i)=>{if(i===index)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
      if (arrow) arrow.disabled=index===groups.length-1;
      revealYear(index,true);
    }
    function update() {
      frame = 0;
      if (!root.isConnected) return;
      const rect = root.getBoundingClientRect();
      const progress = clamp((innerHeight*.25-rect.top)/Math.max(1,root.offsetHeight-innerHeight*.72),0,1);
      root.style.setProperty('--progress',progress.toFixed(4));
      let best = 0;
      if (stickyNavigation) {
        const space = headerSpace(), barHeight = chapters.offsetHeight;
        setLength('--py-history-header',space.visible);
        setLength('--py-history-nav-height',barHeight);
        setLength('--py-history-anchor-header',stickyHeader?space.full:space.visible);
        const bar = chapters.getBoundingClientRect();
        chapters.classList.toggle('is-stuck',bar.top<=space.visible+1&&rect.bottom>space.visible+barHeight);
        const line = space.visible+barHeight+24+Math.min(48,innerHeight*.08);
        groups.forEach((group,i)=>{if(group.getBoundingClientRect().top<=line)best=i;});
        if (pending >= 0) best = pending;
      } else {
        let distance = Infinity;
        groups.forEach((group,i) => {
          const box = group.getBoundingClientRect();
          const delta = Math.abs(box.top+Math.min(box.height,330)/2-innerHeight*.46);
          if (delta<distance) {distance=delta;best=i;}
        });
      }
      select(best);
      if (headerTransitions.size) request();
    }
    function request() { if(!frame&&!signal.aborted)frame=requestAnimationFrame(update); }
    function endJump() {
      if(pending<0)return;
      pending=-1;clearTimeout(settleTimer);clearTimeout(jumpTimer);request();
    }
    function jump(index,push=true,animate=true) {
      const group=groups[index];if(!group)return;group.classList.add('is-visible');
      if(!stickyNavigation){group.scrollIntoView({block:'start',behavior:reduced.matches?'instant':'smooth'});return;}
      clearTimeout(settleTimer);clearTimeout(jumpTimer);
      const space=headerSpace(), absolute=scrollY+group.getBoundingClientRect().top;
      const up=absolute-chapters.offsetHeight-space.visible-24<scrollY;
      const kind=stickyHeader?.dataset.stickyType;
      let clearance=space.visible;
      if(kind==='on-scroll-up')clearance=up?space.full:0;
      else if(kind==='always'||kind==='reduce-logo-size')clearance=space.full;
      pending=index;select(index);
      if(push&&location.hash!=='#'+group.id){
        const url=new URL(location.href);url.hash=group.id;
        try{history.pushState(history.state,'',url);}catch(_){}
      }
      scrollTo({top:Math.max(0,absolute-clearance-chapters.offsetHeight-24),behavior:animate&&!reduced.matches?'smooth':'instant'});
      jumpTimer=setTimeout(endJump,2400);request();
    }
    function onScroll(){request();if(pending>=0){clearTimeout(settleTimer);settleTimer=setTimeout(endJump,180);}}
    addEventListener('scroll',onScroll,{passive:true,signal});
    addEventListener('resize',request,{passive:true,signal});
    reduced.addEventListener('change',()=>{if(reduced.matches){reveal?.disconnect();root.classList.remove('is-reveal-ready');}request();},{signal});
    arrow?.addEventListener('click',()=>jump(Math.min(active+1,groups.length-1)),{signal});
    let headerObserver;
    if(stickyNavigation){
      links.forEach((link,i)=>link.addEventListener('click',event=>{
        if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();jump(i);
      },{signal}));
      chapters.addEventListener('keydown',event=>{
        const index=links.indexOf(document.activeElement);if(index<0||event.altKey||event.ctrlKey||event.metaKey)return;
        let next=index;
        if(event.key==='ArrowRight')next=Math.min(index+1,links.length-1);
        else if(event.key==='ArrowLeft')next=Math.max(index-1,0);
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=links.length-1;
        else return;
        event.preventDefault();links[next].focus({preventScroll:true});revealYear(next,true);
      },{signal});
      const fromHash=()=>{
        let id;try{id=decodeURIComponent(location.hash.slice(1));}catch(_){return;}
        const index=groups.findIndex(group=>group.id===id);if(index>=0)jump(index,false,false);else endJump();
      };
      addEventListener('hashchange',fromHash,{signal});
      addEventListener('popstate',fromHash,{signal});
      addEventListener('scrollend',event=>{if(event.target===document||event.target===window)endJump();},{signal});
      addEventListener('wheel',endJump,{passive:true,signal});
      addEventListener('touchstart',endJump,{passive:true,signal});
      addEventListener('keydown',event=>{if(['PageDown','PageUp','ArrowDown','ArrowUp','Escape',' '].includes(event.key))endJump();},{signal});
      if(header){
        headerObserver=new MutationObserver(request);
        headerObserver.observe(header,{attributes:true,attributeFilter:['class','style']});
        header.addEventListener('transitionrun',event=>{if(event.target===header&&['top','transform','translate'].includes(event.propertyName)){headerTransitions.add(event.propertyName);request();}},{signal});
        for(const eventName of ['transitionend','transitioncancel'])header.addEventListener(eventName,event=>{if(event.target===header){headerTransitions.delete(event.propertyName);request();}},{signal});
      }
      if(location.hash)fromHash();
    }
    const resize=typeof ResizeObserver==='function'?new ResizeObserver(request):null;
    resize?.observe(root);
    if(stickyNavigation){resize?.observe(chapters);if(header)resize?.observe(header);}
    addEventListener('load',request,{once:true,signal});
    document.fonts?.ready.then(()=>{if(!signal.aborted)request();});
    const destroy=()=>{
      controller.abort();reveal?.disconnect();root.classList.remove('is-reveal-ready');resize?.disconnect();headerObserver?.disconnect();headerTransitions.clear();
      cancelAnimationFrame(frame);clearTimeout(settleTimer);clearTimeout(jumpTimer);
      chapters?.classList.remove('is-stuck');
      if(stickyNavigation)for(const name of ['--py-history-header','--py-history-nav-height','--py-history-anchor-header'])root.style.removeProperty(name);
      instances.delete(root);
    };
    instances.set(root,destroy);update();
  }
  const scan=()=>document.querySelectorAll('[data-py-history]').forEach(mount);
  window.pyHistoryTimeline={scan};
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',event=>instances.forEach((destroy,root)=>{if(event.target===root||event.target.contains(root))destroy();}));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();
